import { z } from 'zod';
import { isCalendarDate } from '../../dates/calendar-date.js';
import { beforeEarliestBusinessDateMessage, EARLIEST_BUSINESS_DATE, } from '../zod-helpers/earliest-business-date.js';
/** A form's `YYYY-MM-DD` date string; blank passes because the form, not the schema, supplies a default. */
export const dateStringInput = (label) => z.string({ error: `${label} must be a valid date.` }).superRefine((value, context) => {
    if (value === '')
        return;
    if (!isCalendarDate(value)) {
        context.addIssue({ code: 'custom', message: `${label} must be a valid date.`, path: [] });
    }
    else if (value < EARLIEST_BUSINESS_DATE) {
        context.addIssue({
            code: 'custom',
            message: beforeEarliestBusinessDateMessage(label),
            path: [],
        });
    }
});
//# sourceMappingURL=date-string-input.js.map